import React from 'react';
import { OnboardingChecklist } from '../ui/onboarding-checklist';
import { useStore } from '../../context/StoreContext';

// Optimize Cloudinary URLs for faster loading
const optimizeImageUrl = (url, width) => {
  if (!url || !url.includes('cloudinary.com')) return url;
  return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
};

const FinalCTA = () => {
  const { landingSettings } = useStore();

  const items = [
    { text: "Pure Ceylon Cinnamon", helperText: "Export grade authentic Sri Lankan cinnamon, ethically harvested." },
    { text: "Cold-Pressed Wellness Oils", helperText: "100% natural, nutrient-rich virgin oils for skin and dietary health." },
    { text: "Artisanal Herbal Teas", helperText: "Antioxidant-rich floral blends curated for daily vitality." },
    { text: "Sustainably Sourced", helperText: "Directly supporting local communities and environmental preservation." }
  ];

  const cta1 = landingSettings?.find(s => s.setting_key === 'cta_1')?.image_url || "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313482/1_myygro.png";
  const cta2 = landingSettings?.find(s => s.setting_key === 'cta_2')?.image_url || "https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782313478/2_tck6ul.png";
  
  const images = [optimizeImageUrl(cta1, 600), optimizeImageUrl(cta2, 600)];

  const handleShopClick = () => {
    const shopSection = document.getElementById('shop');
    if (shopSection) {
      shopSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24 relative overflow-hidden bg-gradient-to-b from-brand-sand via-[#e8e4d9] to-[#f0ece1]">
      <div className="max-w-7xl mx-auto relative z-10">
        <OnboardingChecklist
          title="EXPERIENCE PURE CEYLON WELLNESS."
          description="Transform your daily routine with nature's finest ingredients. Authentic, pure, and sustainably sourced directly from our home in Sri Lanka."
          items={items}
          images={images}
          ctaLabel="Shop Now"
          onCtaClick={handleShopClick}
        />
      </div>
    </section>
  );
};

export default FinalCTA;